import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Info } from "@mui/icons-material";
import { Grid, IconButton, InputAdornment, Tooltip } from "@mui/material";

import { useAxios } from "../../../hooks";
import {
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { convertDate } from "../../../utils";
import { Autocomplete, ComponentHeader, TextField } from "../../../components";
import { alert } from "../../../redux/slices/alertSlice";

export function AddNewAgentForm({
  buttons,
  setButton,
  fields,
  setFields,
  handleClose,
  channels,
  formikProps,
}) {
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.memberDetails);

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: "Bearer " + accessToken,
  });

  const handleSubmitClick = async () => {
    const errors = await formikProps.validateForm();
    let prefix = "";
    let missing = flattenErrorsWithValue(errors, (prefix = ""));

    formikProps.setTouched(missing);
    if (Object.keys(errors).length > 0) {
      dispatch(
        alert({
          message:
            "Some fields are invalid or incomplete. Kindly correct them to proceed.",
          type: "error",
        })
      );
      return;
    }

    formikProps.handleSubmit();
  };

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid size={12}>
          <ComponentHeader title={"Delivery Channel Settings"} />
        </Grid>
        <Grid size={4}>
          <Autocomplete
            label={"Select Channel"}
            name="channel_id"
            placeholder="Select Channel"
            defaults={{
              primaryKey: "id",
              displayLabel: "channel_name",
            }}
            sx={{
              "& .MuiSvgIcon-root": {
                display: "none",
              },
            }}
            options={channels}
            onChange={(_, value, type) => handleChangeAudience(value, type)}
            formikProps={formikProps}
          />
        </Grid>
        {fields?.map((field, i) => (
          <Fragment>
            {field.name !== "expiry_token" && (
              <Grid size={4}>
                {/* {field.control_id === 1} */}

                <TextField
                  size="small"
                  formikProps={formikProps}
                  required={field.is_mandatory}
                  name={field.name}
                  label={field.label}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title={field.tooltip}>
                          <IconButton style={{ padding: 0 }}>
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            )}

            {!!formikProps.values.agent_id && field.name === "expiry_token" && (
              <Grid size={4}>
                <TextField
                  size="small"
                  value={convertDate(formikProps.values.expiry_token)}
                  required={field.is_mandatory}
                  name={field.name}
                  label={field.label}
                  disabled
                />
              </Grid>
            )}
          </Fragment>
        ))}
        <Grid size={12} />
        <Grid size="auto" offset={{ xs: "auto" }} />

        <Grid size="auto">
          <PrimaryButton onClick={handleClose} variant="outlined">
            Cancel
          </PrimaryButton>
        </Grid>

        <Grid size="auto">
          <PrimaryLoadingButton
            type="submit"
            variant="contained"
            onClick={handleSubmitClick}
          >
            Submit
          </PrimaryLoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );

  function handleChangeAudience(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        channel_id: value.id,
        channelName: value.channel_name,
      }));

      axios({
        url: "/bot/get-agent-fields/" + value.id,
      }).then((response) => {
        if (response.status) {
          setFields(response?.data?.data);
          setButton(response.data?.pdf);
        }
      });
    } else {
      value = {
        id: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        channel_id: value.id,
      }));
    }
  }
}

function flattenErrorsWithValue(obj, prefix = "") {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (value && typeof value === "object" && !Array.isArray(value)) {
      if (
        "value" in value &&
        typeof value.value === "object" &&
        !Array.isArray(value.value)
      ) {
        Object.assign(
          acc,
          flattenErrorsWithValue(value.value, `${newKey}.value`)
        );
      } else if ("value" in value) {
        acc[`${newKey}.value`] = true;
      } else {
        Object.assign(acc, flattenErrorsWithValue(value, newKey));
      }
    } else {
      acc[newKey] = true;
    }

    return acc;
  }, {});
}
